import EmbedCodeContainer from './embed_code_container.js'

export default {
  EmbedCodeContainer,
}
